import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfiguration } from 'app/app-configuration';
import { Observable } from 'rxjs';
import { LicenseNotificationsModel } from './license-notifications.model';

@Injectable({providedIn: 'root'})
export class LicenseNotificationsRestService {

  private readonly controllerUrl: string = this.appConfiguration.serverApiUrl + '/secured/license-notifications';

  constructor(private httpClient: HttpClient,
              private appConfiguration: AppConfiguration) {
  }

  getLicenseParameters(): Observable<LicenseNotificationsModel> {
    return this.httpClient.get<LicenseNotificationsModel>(this.controllerUrl);
  }

  saveLicenseParameters(licenseNotifications: LicenseNotificationsModel): Observable<LicenseNotificationsModel> {
    return this.httpClient.put<LicenseNotificationsModel>(this.controllerUrl, licenseNotifications);
  }

  showLicenseExpirationDialog(): Observable<LicenseNotificationsModel> {
    return this.httpClient.get<LicenseNotificationsModel>(this.controllerUrl + '/show-dialog');
  }
}
